// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class ApplicationVersion {
    toString() {
        let versionStr = `${this.version}.${this.build}.${this.buildVersion}`;
        if (isValidNumber(this.developerVersion) && this.developerVersion !== 0) {
            versionStr += `-${this.developerVersion}`;
        }
        return versionStr;
    }
    isPartialOlderThan(otherVersion) {
        if (isNullOrUndefined(otherVersion))
            return false;
        if (this.version !== otherVersion.version)
            return this.version < otherVersion.version;
        if (this.build !== otherVersion.build)
            return this.build < otherVersion.build;
        return this.buildVersion < otherVersion.buildVersion;
    }
    isEqualTo(otherVersion) {
        if (isNullOrUndefined(otherVersion))
            return false;
        if (this.version !== otherVersion.version)
            return false;
        if (this.build !== otherVersion.build)
            return false;
        if (this.buildVersion !== otherVersion.buildVersion)
            return false;
        const thisDev = isValidNumber(this.developerVersion) ? this.developerVersion : 0;
        const otherDev = isValidNumber(otherVersion.developerVersion) ? otherVersion.developerVersion : 0;
        return thisDev === otherDev;
    }
    serialize() {
        const dto = {
            version: String(this.version),
            build: String(this.build),
            build_version: String(this.buildVersion),
            developer_version: String(this.developerVersion),
            date_day: this.dateDay,
            force_update: this.forceUpdate
        };
        return JSON.stringify(dto);
    }
    deserialize(json) {
        const dtoObj = JSON.parse(json);
        this.version = Number(dtoObj.version);
        this.build = Number(dtoObj.build);
        this.buildVersion = Number(dtoObj.build_version);
        this.developerVersion = Number(dtoObj.developer_version);
        this.dateDay = dtoObj.date_day;
        this.forceUpdate = Boolean(dtoObj.force_update);
    }
    static createApplicationVersionByJson(json) {
        if (!isValidString(json)) {
            return null;
        }
        try {
            const appVersion = new ApplicationVersion();
            appVersion.deserialize(json);
            return appVersion;
        }
        catch (e) {
            return null;
        }
    }
}
export class ApplicationVersionDTO {
}
